import {PageHeader, CardComponent} from '@/components/molecules';
import {HeaderTitle, LinkText} from '@/components/atoms';
import {useNavigate} from 'react-router-dom';
import {ROUTES} from '@/utils/constants/routesConstants';
import {Header} from '@/utils/constants/header';
import {useAppDispatch} from '@/store';
import {resetPerfectStore} from '@/store/slices/perfectStoreSlice';
import {usePerfectStoreQuery} from '@/hooks/usePerfectStoreQuery';

export const PerfectStoreHome = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {perfectStoreList, isLoading} = usePerfectStoreQuery();

  const handleAddPerfectStore = () => {
    dispatch(resetPerfectStore());
    navigate(ROUTES.PERFECT_STORE_ADD);
  };

  const handleRowClick = (row) => {
    const rowId = row?.id ?? row?.uuid;
    if (!rowId) return;
    navigate(
      ROUTES.PERFECT_STORE_DETAIL.replace(':id', encodeURIComponent(rowId))
    );
  };

  const cardList = [
    {
      centralIcon: 'storefront',
      ctaPrimary: {
        text: 'Add Perfect Store Target',
        onClick: handleAddPerfectStore
      },
      title: 'Perfect Store Targets'
    }
  ];

  return (
    <div
      className='salesTargetsContainer flex flex-col'
      data-testid='perfect-store-home'>
      <PageHeader title='Perfect Store' />
      <div
        className='targetCardComponent mb-5 flex flex-wrap'
        data-testid='perfect-store-cards'>
        <CardComponent cardList={cardList} isLoading={false} />
      </div>
      <div
        style={{
          backgroundColor: 'var(--color-background-layer-01)',
          paddingLeft: '16px'
        }}
        className='salesTargetsTitleSection relative'
        data-testid='perfect-store-list'>
        <HeaderTitle
          headingLevel={Header.SectionTitle}
          title='Perfect Store List'
          className='salesTargetsDataTableHeading'
        />
        <div className='py-4 pr-4 text-[color:var(--color-text-primary)]'>
          {isLoading && (
            <p data-testid='perfect-store-list-loading'>Loading...</p>
          )}
          {!isLoading && perfectStoreList.length === 0 && (
            <p data-testid='perfect-store-list-empty'>
              No Perfect Store targets found.
            </p>
          )}
          {!isLoading &&
            perfectStoreList.map((row) => {
              const rowId = row?.id ?? row?.uuid;
              return (
                <div key={rowId || row?.name} className='mb-2'>
                  <LinkText
                    text={row?.name || 'Untitled'}
                    id={`perfect-store-${rowId}`}
                    handleClick={() => handleRowClick(row)}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
